import RailBlock from './RailBlock.jsx'
import { useAboutSite } from '../context/AboutSiteContext.jsx'

function AboutSiteTrigger({ borderTop = true }) {
  const { openAbout } = useAboutSite()

  return (
    <RailBlock eyebrow="About this site" borderTop={borderTop}>
      <button
        onClick={openAbout}
        className="w-full flex justify-between items-center py-3 border-b border-soft-rule text-[14px] text-soft-ink hover:text-soft-dim transition-colors group text-left cursor-pointer bg-transparent"
      >
        <span>How this site is built</span>
        <span className="font-mono text-[12px] text-soft-faint group-hover:text-soft-dim transition-colors">→</span>
      </button>
    </RailBlock>
  )
}

export default AboutSiteTrigger
